export default __webpack_public_path__ + "static/media/7-eleven-brand-family.4f1a9bf3.png";